import styled from "@emotion/styled";

import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import RichText from "./RichText";

// Blocs configurés côté admin (texte libre, texte encadré, condition à cocher).
function FormConfigBlocks({ blocks, acceptedConditions, onToggleCondition }) {
  return (
    <>
      {blocks.map((block, index) => {
        if (block.type === "CONDITION") {
          return (
            <ConditionContainer key={index}>
              <FormControl required component="fieldset" variant="standard">
                {block.title && (
                  <FormLabel component="legend">{block.title}</FormLabel>
                )}

                <StyledFormGroup>
                  <StyledFormControlLabel
                    control={
                      <Checkbox
                        checked={!!acceptedConditions[index]}
                        onChange={() => onToggleCondition(index)}
                      />
                    }
                    label={<RichText content={block.content} />}
                  />
                </StyledFormGroup>
              </FormControl>
            </ConditionContainer>
          );
        }

        if (block.framed) {
          return (
            <Alert
              key={index}
              severity="info"
              variant="outlined"
              sx={{ marginBottom: "16px" }}
            >
              {block.title && <AlertTitle>{block.title}</AlertTitle>}
              <RichText content={block.content} />
            </Alert>
          );
        }

        return (
          <StyledText key={index}>
            <RichText content={block.content} />
          </StyledText>
        );
      })}
    </>
  );
}

const ConditionContainer = styled.div`
  margin: 16px 0;
`;

const StyledFormGroup = styled(FormGroup)`
  margin-top: 8px;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  color: #575757;
`;

const StyledText = styled(Typography)`
  margin: 24px 0;
  color: #6c6c6c;
`;

export default FormConfigBlocks;
